import Card from "@rio-cloud/rio-uikit/Card";
import { useT } from "@hooks";

export interface TopTollPlazaItem {
  rank: number;
  name: string;
  location?: string;
  concessionaria: string;
  count: number;
}

interface TopTollPlazasCardProps {
  items: TopTollPlazaItem[];
}

const RankBadge = ({ rank }: Readonly<{ rank: number }>) => (
  <div
    className="display-flex align-items-center justify-content-center text-color-white text-medium"
    style={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: "#30B4C0", fontSize: 14, flexShrink: 0 }}
  >
    {rank}
  </div>
);

export default function TopTollPlazasCard({ items }: Readonly<TopTollPlazasCardProps>) {
  const t = useT();

  return (
    <Card className="padding-y-25 padding-x-15 padding-x-25-sm">
      <div className="display-flex flex-column gap-5 padding-bottom-20">
        <span className="text-size-20 text-bold">{t("tolls.chart.topPlazas.title")}</span>
        <span className="text-size-16 text-color-gray">{t("tolls.chart.topPlazas.subtitle")}</span>
      </div>

      <div className="display-flex flex-column">
        {items.map((item) => (
          <div
            key={item.rank}
            className="display-flex align-items-center gap-15 padding-y-15"
            style={{ borderBottom: "1px solid #E5EBF0" }}
          >
            <RankBadge rank={item.rank} />
            <div className="display-flex flex-column flex-1-1 min-width-0">
              <span className="text-size-16">{item.location ? `${item.name} - ${item.location}` : item.name}</span>
              <span className="text-color-gray text-size-14">{item.concessionaria}</span>
            </div>
            <span className="text-size-20 text-color-rating-5 flex-0">{item.count}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
